import type { LessonType } from "@prisma/client";

/** Skill spoke on the radar / lesson board. LISTENING is practiced via DICTATION lessons. */
export type Modality = "READING" | "WRITING" | "SPEAKING" | "LISTENING";

/** Radar clockwise order: READING, WRITING, SPEAKING, LISTENING. */
export const MODALITIES: readonly Modality[] = [
  "READING",
  "WRITING",
  "SPEAKING",
  "LISTENING",
] as const;

export function modalityToLessonType(modality: Modality): LessonType {
  return modality === "LISTENING" ? "DICTATION" : modality;
}

export function lessonTypeToModality(lessonType: LessonType): Modality {
  return lessonType === "DICTATION" ? "LISTENING" : lessonType;
}
